import { Stack, TableCell, TableBody, TableRow } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
// import LoadingImage from "../../Assets/loading_icon.gif.mp4";

export default function LoadingPage({ colSpan, height }) {
  return (
    <>
      {colSpan ? (
        <TableBody className="body">
          <TableRow className="body-row">
            <TableCell colSpan={colSpan} className="body-cell">
              <Stack direction="column" justifyContent="center" height={height ? height : "300px"} bgcolor="white" width="100%">
                <Stack direction="row" justifyContent="center">
                  <CircularProgress color="primary" />
                </Stack>
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      )
        : (
          <Stack direction="column" justifyContent="center" height={height ? height : "300px"} bgcolor="white" width="100%">
            <Stack direction="row" justifyContent="center">
              <CircularProgress color="primary" />
            </Stack>
          </Stack>
        )
      }
    </>
  );
}

export function LoadingTr({ colSpan }) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <Stack direction="row" justifyContent="center" height="200px" alignItems='center'>
          <CircularProgress color="primary" />
        </Stack>
      </td>
    </tr>
  )
}